import type { EchoflicksSessionMedia } from "../types";
import { useMediaUrl } from "./useMediaUrl";

export function FramingEvidenceImage({
  media,
  sceneId,
}: {
  media?: EchoflicksSessionMedia;
  sceneId: string;
}) {
  const evidence = useMediaUrl(media);

  if (!evidence.url) return null;

  return (
    <a
      href={evidence.url}
      target="_blank"
      rel="noreferrer"
      className="mt-4 block overflow-hidden rounded-md border bg-muted/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <img
        src={evidence.url}
        alt={`Framing evidence reported for scene ${sceneId}`}
        loading="lazy"
        className="h-auto max-h-72 w-full object-contain"
      />
    </a>
  );
}
